import { CheckboxYesNo, FormContainer, LabeledInput, Worksheet } from "uikit"
import { propertySchema } from "components/properties/propertySchema"
import React from "react"
import { Input } from "semantic-ui-react"
import { useStore } from "store"
import { Footer } from "./Footer"

const RealEstatePropertyForm = ({
  data: {
    fields: { description, value, property_taxes, is_primary_residence },
    isModified,
    onSubmit,
    isPending,
    hasError,
    error
  },
  submitLabel = "Done",
  submitHeader = "",
  onDelete,
  isNew,
  hasFrmAccount,
  hasPrimaryResidence
}) => {
  const confirmText = hasFrmAccount ? (
    <span>
      Deleting this property will also delete its mortgage.
      <strong> You cannot undo this action.</strong>
    </span>
  ) : (
    <span>
      If you proceed, you will permanently remove this account.
      <strong>YOU CANNOT UNDO THIS ACTION.</strong>
    </span>
  )
  return (
    <Worksheet error={error}>
      <Worksheet.Body>
        <Worksheet.Row
          label="What do you want to call this property?"
          description="A short name or label we can use to refer to this property as we work together."
          paddedField
        >
          <Worksheet.Field error={description.error}>
            <Input {...description} autoComplete="off" />
          </Worksheet.Field>
        </Worksheet.Row>
        <Worksheet.Row label="What's the current market value?" paddedField>
          <Worksheet.Field error={value.error}>
            <LabeledInput
              {...value}
              label=""
              iconText="$"
              iconPosition="left"
              placeholder="0"
            />
          </Worksheet.Field>
        </Worksheet.Row>
        <Worksheet.Row
          label="What are the annual property taxes on this property?"
          description="Your property taxes may be billed bi-annually or quarterly and may be paid as part of your mortgage payment."
          paddedField
        >
          <Worksheet.Field error={property_taxes.error}>
            <LabeledInput
              {...property_taxes}
              label=""
              iconText="$"
              iconPosition="left"
              placeholder="0"
            />
          </Worksheet.Field>
        </Worksheet.Row>
        {!hasPrimaryResidence ? (
          <Worksheet.Row label="Is this your primary residence?" paddedField>
            <Worksheet.Field error={is_primary_residence.error}>
              <CheckboxYesNo fluid {...is_primary_residence} />
            </Worksheet.Field>
          </Worksheet.Row>
        ) : null}
      </Worksheet.Body>
      <Footer
        deleteLabel="Delete Property"
        isNew={isNew}
        deleteText={confirmText}
        onDelete={onDelete}
        submitLabel={submitLabel}
        onSubmit={onSubmit}
        isModified={isModified}
        error={error}
      />
    </Worksheet>
  )
}

const RealEstatePropertyFormContainer = FormContainer(
  propertySchema,
  (fields, ...form) => {}
)(RealEstatePropertyForm)

const RealEstateProperty = ({ household, property, ...formProps }) => {
  const [properties] = useStore("householdProperties", household.id)
  const [accounts] = useStore("householdAccounts", household.id)

  const isNew = property === null
  const values = isNew ? {} : Object.assign({}, property)
  let hasPrimaryResidence = false
  const primaryResidence = Object.values(properties).find(
    property => property.is_primary_residence === true
  )
  if (primaryResidence) {
    if (isNew) {
      hasPrimaryResidence = true
    } else if (primaryResidence.id !== property.id) {
      hasPrimaryResidence = true
    }
  }
  if (hasPrimaryResidence === false && isNew) {
    Object.assign(values, { is_primary_residence: true })
  }
  const frmAccounts = Object.values(accounts).filter(
    ({ type }) => type === "frm"
  )
  const hasFrmAccount = frmAccounts.find(
    account => account.property_id === values.id
  )
  return (
    <RealEstatePropertyFormContainer
      {...{
        values,
        hasFrmAccount,
        hasPrimaryResidence,
        ...formProps
      }}
    />
  )
}

export default RealEstateProperty
